import { apiClient } from '../publicApiClient';

export interface SEOData {
  title: string;
  description: string;
  keywords: string;
  image: string;
  url: string;
  type: 'website' | 'article' | 'profile';
  structuredData?: any;
}

/**
 * Fetches SEO data for a specific entity type and ID from the backend.
 * This must use a public client because search engine crawlers are not authenticated.
 *
 * @param entityType - The type of the entity (e.g., 'space', 'room').
 * @param entityId - The ID of the entity.
 * @returns A promise that resolves to the SEOData object.
 */
const fetchSEOData = async (entityType: 'space' | 'room', entityId: string): Promise<SEOData> => {
  try {
    // Use the publicApiClient and a relative path to resolve to the correct SEO endpoint
    const response = await apiClient.axiosInstance.get<SEOData>(`../seo/${entityType}s/${entityId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch SEO data for ${entityType} ${entityId}:`, error);
    // On error, we can re-throw to be handled by the caller,
    // allowing for fallback to default translated SEO tags.
    throw new Error(`Failed to fetch SEO data`);
  }
};

export const seoService = {
  fetchSEOData,
}; 